<template>
  <div class="box">
    <a-spin :spinning="loading">
      <div class="contet-warp main-width">
        <div class="title">{{ data.title }}</div>
        <div class="time">发布时间：{{ data.updateTime }}</div>
        <div class="content">
          <p class="markdown-body" v-html="data.html"></p >
        </div>
      </div>
      <link :href="css" rel="stylesheet" type="text/html">
    </a-spin>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'Home',
  mounted () {
    this.queryDetail()
  },
  data () {
    return {
      loading: false,
      matchFun: matchFun,
      id: this.$route.query.id,
      data: {},
      css: require('@comm/assets/css/github-markdown.min.css')
    }
  },
  methods: {
    queryDetail () {
      this.loading = true
      this.$api.match.matchNoticesDetail({id: this.id}).then(res => {
        this.loading = false
        if (res.status === 0) {
          this.data = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  background: #fff;
}
.main-width {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
  .title{
      font-size: 24px;
      color: #000;
      text-align: center;
      line-height: 30px;
      padding: 20px 0;
      padding-top: 40px;
      font-weight: bold;
      margin-top: 40px;
  }
  p{
    line-height: 20px;
    font-size: 16px;
    color: #666;
  }
  .text-title{
    font-weight: bold;
    color: #000;
  }
  .time{
      width: 220px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
      border-radius: 4px;
      padding: 5px 10px;
      margin-bottom: 20px;
  }
  .content{
      font-size: 16px;
      color: #444;
      min-height: 494px;
      text-indent: 20px;
      line-height: 35px;
      padding: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchNoticeDetail.vue